import './design-system/styles.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app/App';
import { defaultResources, loadLocale } from './app/i18n';
import { initSentry } from './app/sentry';
import { initI18n } from './shared/i18n';

async function bootstrap() {
  void initSentry();
  // Inline env check (not `env.apiMock`): Vite replaces it at build time, so a production build without mocks drops
  // the whole mock backend — seed data and demo credentials never reach the bundle.
  if (import.meta.env.VITE_API_MOCK === 'true') {
    const { startMockWorker } = await import('./mocks');
    await startMockWorker();
  }
  await initI18n(defaultResources, loadLocale);
  const root = document.getElementById('root');
  if (!root) throw new Error('Root element missing');
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void bootstrap();
